import { LEASE_OPTIONS, useLeaseCompanyOptions } from "modules/LeadsDashboard/hooks";
import { setLeadsCarsFilters, useLeadsCarsFilters } from "modules/LeadsDashboard/Leads/CarsLeads/hooks";
import { LEADS_CARS_STORAGE_KEYS } from "modules/LeadsDashboard/storageKeys";
import { setPreference } from "utils/common";

import type { OnChangeFn, PaginationState } from "@tanstack/react-table";
import type { PAGE_SIZE } from "utils/common";

export const useCarsTableFiltersHandlers = () => {
  const carsFilters = useLeadsCarsFilters();
  const { page: currentPage, page_size: pageSize } = carsFilters;
  const { leaseCompanyOptions } = useLeaseCompanyOptions();

  const onPageChange = (data: { activePage: number }) => setLeadsCarsFilters({ ...carsFilters, page: data.activePage });
  const handlePaginationSelect: OnChangeFn<PaginationState> = updater => {
    const newState = typeof updater === "function" ? updater({ pageIndex: currentPage - 1, pageSize }) : updater;
    onPageChange({ activePage: newState.pageIndex + 1 });
  };

  const handlePageSizeChange = (value: PAGE_SIZE) => {
    setPreference(LEADS_CARS_STORAGE_KEYS.PageSizePreference, value);
    setLeadsCarsFilters({ ...carsFilters, page_size: value, page: 1 });
  };

  const handleOnLeaseSelect = (leaseCompany: string[]) => {
    const selectedLeaseCompanyValue = leaseCompanyOptions.find(option => option.value === leaseCompany[0]) || null;

    let is_lease_company: boolean | null = null;
    if (selectedLeaseCompanyValue && selectedLeaseCompanyValue.value !== LEASE_OPTIONS.All) is_lease_company = selectedLeaseCompanyValue.value === LEASE_OPTIONS.Lease;

    setPreference(LEADS_CARS_STORAGE_KEYS.LeaseCompanyPreference, is_lease_company);
    setLeadsCarsFilters({ ...carsFilters, is_lease_company, page: 1 });
  };

  return { handleOnLeaseSelect, handlePaginationSelect, handlePageSizeChange };
};
